/** Per-route SEO meta for public pages (set in React, not Builder CMS). */
export type PublicPageMeta = {
  title: string;
  description: string;
};

export const PUBLIC_PAGE_META: Record<string, PublicPageMeta> = {
  '/': {
    title: 'PRAIRI | Matching Startups & Investors Worldwide',
    description:
      'Global platform matching the right startups with the right investors — for earlier discovery beyond your network.',
  },
  '/investors': {
    title: 'Discover the Right Startups Faster | PRAIRI For Investors',
    description:
      'Private, personalised startup deal flow beyond your network. Review relevant startups anonymously and connect with founders through PRAIRI.',
  },
  '/investors/pricing': {
    title: 'PRAIRI Investor Plans | Access Relevant Startups',
    description:
      'Discover thesis-matched startups earlier and beyond your network. Compare PRAIRI investor plans and choose how you invest.',
  },
  '/startups': {
    title: 'Get Discovered by Startup Investors | PRAIRI for Startups',
    description:
      'Get discovered by relevant startup investors beyond your network. Create your profile, upload your pitch deck, and let interested investors reach out to you.',
  },
  '/about-us': {
    title: 'About PRAIRI | Building Better Startup Funding',
    description:
      "Meet the team behind PRAIRI and learn how we're helping startups and investors connect through relevance-based discovery and matching.",
  },
};

export function getPublicPageMeta(pathname: string): PublicPageMeta | undefined {
  return PUBLIC_PAGE_META[pathname];
}
